import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

type InitialState = {
  viewReviewModal: boolean;
  reviewId: null | number;
};

const initialState: InitialState = {
  viewReviewModal: false,
  reviewId: null,
};

const viewReviewModalSlice = createSlice({
  name: "viewReviewModalSlice",
  initialState,
  reducers: {
    openViewReviewModal: (
      state,
      action: PayloadAction<{
        reviewId: number;
      }>
    ) => {
      state.viewReviewModal = true;
      state.reviewId = action.payload.reviewId;
      return state;
    },
    closeViewReviewModal: (state, action: PayloadAction) => {
      state.viewReviewModal = false;
      state.reviewId = null;
      return state;
    },
  },
});

export const { openViewReviewModal,closeViewReviewModal } = viewReviewModalSlice.actions;
export default viewReviewModalSlice;
